import {Injectable} from '@angular/core';
import {ApiArticle} from '@iw-shop/api/articles';
import {locationsArticle} from '@store/actions/global.actions';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {ActivatedRoute, Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ArticleTemplateService {

  constructor(protected store: Store<AppState>,
              protected router: Router,
              protected route: ActivatedRoute) {
  }

  getParamForUrl(param?: string): string {
    if(param){
        let regex = new RegExp('', )
      param = param.replace(/[^A-Za-z0-9 ]/g, "").toLowerCase();
      return encodeURIComponent(param);
    }
    return '';
  }

  goToArticle(article: ApiArticle | undefined, saveCurrentRouteForBreadcrumb = true) {
    if(!article){
      return;
    }
    let url = this.router.url.split('?')[0].split('#')[0];
    if(saveCurrentRouteForBreadcrumb){
      this.store.dispatch(locationsArticle({articleId: article.id, listRouterUrl: url , listQueryParams: this.route.snapshot.queryParams}));
    }

    this.router.navigate(['/sortiment/details/', article.articleNumber, this.getParamForUrl(article.name)]).then();
  }
}
